import bg from './bg.json';
import cs from './cs.json';
import da from './da.json';
import de from './de.json';
import en from './en.json';
import enGB from './en-GB.json';
import enUS from './en-US.json';
import es from './es.json';
import fi from './fi.json';
import fr from './fr.json';
import hr from './hr.json';
import hu from './hu.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import nb from './nb.json';
import nl from './nl.json';
import pl from './pl.json';
import pt from './pt.json';
import ptbr from './pt-br.json';
import ru from './ru.json';
import sv from './sv.json';
import tr from './tr.json';
import uk from './uk.json';
import zh from './zh.json';
import zhTW from './zh-TW.json';

export default {
  bg,
  cs,
  da,
  de,
  en,
  'en-GB': enGB,
  'en-US': enUS,
  es,
  fi,
  fr,
  hr,
  hu,
  it,
  ja,
  ko,
  nb,
  nl,
  pl,
  pt,
  'pt-br': ptbr,
  ru,
  sv,
  tr,
  uk,
  zh,
  'zh-TW': zhTW,
};
